import { useState } from "react";
import { getFileDownloadUrl } from "../../../../api/firebase/firestoreService";

interface UsePdfFetchingFromFilepathState {
  downloadUrl: string;
  loading: boolean;
  error: string;
}
export const usePdfFetchingFromFilepath = () => {
  const [pdfFetchingState, setPdfFetchingState] =
    useState<UsePdfFetchingFromFilepathState>({
      downloadUrl: "",
      loading: false,
      error: "",
    });
  const fetchDownloadUrl = async (firebasePathRef: string) => {
    try {
      setPdfFetchingState((prev) => ({ ...prev, loading: true, error: "" }));
      const downloadUrl = await getFileDownloadUrl(firebasePathRef);
      if (downloadUrl) {
        setPdfFetchingState((prev) => ({
          ...prev,
          downloadUrl,
          loading: false,
          error: "",
        }));
      } else {
        setPdfFetchingState((prev) => ({
          ...prev,
          loading: false,
          error: "Failed to get download URL from Firebase Storage",
        }));
      }
    } catch (error) {
      setPdfFetchingState((prev) => ({
        ...prev,
        loading: false,
        error: "Failed to get download URL from Firebase Storage",
      }));
    }
  };

  return {
    downloadUrl: pdfFetchingState.downloadUrl,
    loading: pdfFetchingState.loading,
    error: pdfFetchingState.error,
    fetchDownloadUrl,
  };
};
